export default {"src":"/_next/static/media/dawn-evry-logo.034568af.svg","height":32,"width":235};